import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';

class ContactForm extends React.Component {

  renderField = ({
    input,
    label,
    placeholder,
    type,
    disabled,
    readOnly,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <input
            {...input}
            className="form-control"
            placeholder={placeholder}
            type={type}
            disabled={disabled}
            readOnly={readOnly}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  renderTextArea = ({ input, label, readOnly, meta: { touched, error, warning } }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          className="form-control"
          placeholder={label}
          readOnly={readOnly}
          rows="5"
          cols="30"
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderLocationsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          isMulti
          loadOptions={this.searchLocations}
          getOptionValue={(option) => option.clinicLocationID}
          getOptionLabel={(option) => (option.clinicLocation === undefined) ? option.siteName : option.clinicLocation.siteName}
          placeholder="Type Location Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onLocationChange = (val) => {
    this.props.change('locations', val);
  }

  searchLocations = (search) => {
    return this.props.searchLocations(search, 'isActive');
  }

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.clientID}
          getOptionLabel={(option) => (option.client === undefined) ? option.employerCodeDescription : option.client.employerCodeDescription}
          placeholder="Type Client Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchClients = (search) => {
    return this.props.searchClients(search);
  }

  onClientChange = (val) => {
    this.props.change('clients', val);
  }

  renderPatientsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          isMulti
          loadOptions={this.searchPatients}
          getOptionValue={(option) => option.masterPatientID}
          getOptionLabel={(option) => (option.patient === undefined) ? (option.fullName) : (option.patient.fullName)}
          placeholder="Type Patient Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPatientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchPatients = (search) => {
    return this.props.searchPatients(search);
  }

  onPatientChange = (val) => {
    this.props.change('patients', val);
  }

  renderReferralsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          isMulti
          loadOptions={this.searchReferrals}
          getOptionValue={(option) => option.referralID}
          getOptionLabel={(option) => (option.referral === undefined) ? (option.resource) : (option.referral.resource)}
          placeholder="Type Referral Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onReferralChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchReferrals = (search) => {
    return this.props.searchReferrals(search);
  }

  onReferralChange = (val) => {
    this.props.change('referrals', val);
  }

  renderContactTypesSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          isMulti
          loadOptions={this.searchContactTypes}
          getOptionValue={(option) => option.typeID}
          getOptionLabel={(option) => (option.contacttype === undefined) ? (option.name) : (option.contacttype.name)}
          placeholder="Type Contact Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onContactTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchContactTypes = () => {
    return this.props.searchContactTypes();
  }

  onContactTypeChange = (val) => {
    this.props.change('types', val);
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      mode,
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Contact</legend>
          <Field
            className="form-control"
            name="company"
            component={this.renderField}
            type="text"
            placeholder="Company"
            label="Company"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="contactName"
            component={this.renderField}
            type="text"
            placeholder="ContactName"
            label="ContactName"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="phone1"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Phone1"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="phone2"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Phone2"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="fax"
            component={this.renderField}
            type="text"
            placeholder="Fax"
            label="Fax"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="email1"
            component={this.renderField}
            type="text"
            placeholder="your.email@company.com"
            label="Email"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="website"
            component={this.renderField}
            type="text"
            placeholder="Website"
            label="Website"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="description"
            component={this.renderTextArea}
            type="text"
            placeholder="Description"
            label="Description"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            name="types"
            component={this.renderContactTypesSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Contact Types"
          />
          <Field
            name="locations"
            component={this.renderLocationsSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Locations"
          />
          <Field
            name="clients"
            component={this.renderClientsSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Clients"
          />
          <Field
            name="patients"
            component={this.renderPatientsSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Patients"
          />
          <Field
            name="referrals"
            component={this.renderReferralsSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Referral Resources"
          />
        </fieldset>

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.company) {
    errors.company = 'Required';
  }
  if (!values.contactName) {
    errors.contactName = 'Required';
  }
  if (!values.phone1) {
    errors.phone1 = 'Required';
  } else if (!/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/i.test(values.phone1)) {
    errors.phone1 = 'Invalid phone ex. (XXX) XXX-XXXX';
  }
  if (!values.email1) {
    errors.email1 = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email1)) {
    errors.email1 = 'Invalid email address';
  }
  if (!values.website) {
    errors.website = 'Required';
  }
  if (!values.description) {
    errors.description = 'Required';
  }
  if (!values.types) {
    errors.types = 'Required';
  }

  return errors;
};

ContactForm = connect(state => ({
  formValues: getFormValues('contact')(state),
  initialValues: state.contactmanager.contact,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'contact' })(ContactForm));
export default ContactForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/ContactForm.js